import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeStatusReport'
})
export class PipeStatusReport implements PipeTransform {
    constructor() {}
    transform(report) {
        if(report == 'Parado'){
            return 'text-success';
        } else if(report == 'Iniciado'){
            return 'text-warning';
        } else if(report == 'Concluido'){
            return 'text-success';
        } else {
            return 'text-danger';
        }
      }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeStatusReport.ts